import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { getStorage, setStorage } from '../utils/storegeUtils';

const PERSIST_SERVER_CONF = 'config_ai_server_conf';
const PERSIST_SYSTEM_AI = 'config_ai_system';
const PERSIST_TEMPERATURE_AI = 'config_ai_temperature';
const AIConfigContext = createContext();

const actions = {
  CHANGE_AI_SERVER: 'CHANGE_AI_SERVER',
  CHANGE_AI_SYSTEM: 'CHANGE_AI_SYSTEM',
  CHANGE_AI_TEMPERATURE: 'CHANGE_AI_TEMPERATURE',
};

const initialState = {
  serverApi: JSON.parse(
    getStorage(PERSIST_SERVER_CONF) || '{"api":"https://edelvivesdigital-dev.oneclickaws.tk/api","token":""}'
  ),
  systemAi: getStorage(PERSIST_SYSTEM_AI) || '',
  temperatureAi: getStorage(PERSIST_TEMPERATURE_AI) || '0.7',
};

function aiConfigReducer(state, action) {
  switch (action.type) {
    case actions.CHANGE_AI_SERVER: {
      try {
        setStorage(PERSIST_SERVER_CONF, JSON.stringify(action.payload.serverApi));
        return { ...state, serverApi: action.payload.serverApi };
      } catch (err) {
        console.log(err);
      }
      break;
    }
    case actions.CHANGE_AI_SYSTEM: {
      setStorage(PERSIST_SYSTEM_AI, action.payload.systemAi);
      return { ...state, systemAi: action.payload.systemAi };
    }
    case actions.CHANGE_AI_TEMPERATURE: {
      setStorage(PERSIST_TEMPERATURE_AI, action.payload.temperatureAi);
      return { ...state, temperatureAi: action.payload.temperatureAi };
    }
    default: {
      throw new Error(`Unsupported action type: ${action.type}`);
    }
  }
}

function useAIConfig() {
  const context = useContext(AIConfigContext);
  if (!context) {
    throw new Error(`useAIConfig must be used within a AIConfigProvider`);
  }
  const [state, dispatch] = context;

  useEffect(() => {}, []);

  const setServerApi = (conf) => dispatch({ type: actions.CHANGE_AI_SERVER, payload: { serverApi: conf } });
  const setSystemAi = (system) => dispatch({ type: actions.CHANGE_AI_SYSTEM, payload: { systemAi: system } });
  const setTemperatureAi = (temperature) =>
    dispatch({ type: actions.CHANGE_AI_TEMPERATURE, payload: { temperatureAi: temperature } });

  return {
    aiConfig: state,
    dispatch,
    setServerApi,
    setSystemAi,
    setTemperatureAi,
  };
}

function AIConfigProvider(props) {
  const [state, dispatch] = useReducer(aiConfigReducer, initialState);
  const value = useMemo(() => [state, dispatch], [state]);
  return <AIConfigContext.Provider value={value} {...props} />;
}

export { AIConfigProvider, useAIConfig };
